import axios from "axios";
import router, {ROUTES} from "../router";
import { storage } from "../helpers/storage";

export const saveToken = async (token) => {
  await storage.setItem('token', token);
}

// auth header
export const authHeader = async () => {
  const param = new URLSearchParams(window.location.search);
  let token = param.get('token');
  // console.log('auth header')

  if (token) {
    await saveToken(token);

    // Видаляємо токен з URL після збереження
    const url = new URL(window.location);
    url.searchParams.delete('token');
    window.history.replaceState({}, '', url);
  } else {
    token = await storage.getItem('token');
  }

  return {Authorization: `Bearer ${token}`};
};

export const instance = axios.create({
  // baseURL: process.env.NODE_ENV !== "production" ? 'http://local.ce-go.l' : '', // TODO TAKE IT FROM ENV FILE
  headers: {
    common: {
      // ...authHeader(),
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  },
});

// Додаємо interceptor для headers перед кожним запитом
instance.interceptors.request.use(
  async (config) => {
    const auth = await authHeader();
    config.headers = {
      ...config.headers,
      ...auth
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => response,
  async error => {
    const status = error?.response?.status;
    // console.log("status", status);
    // if any response return 404 - redirect to error page
    // if ([404].includes(status)) {
    //   router.push({ name: 'Error Page', params: { status } });
    // }

    //if 401 - remove token from local store and headers and redirect to access page
    if (status === 401) {
      await storage.removeItem('token');
      await storage.removeItem('attendee_id');
      instance.defaults.headers['Authorization'] = '';

      router.push(ROUTES.ACCESS);
    }

    return Promise.reject(error);
  }
);

export const resetAuthHeadersAndLocalStore = async () => {
  await storage.removeItem('token');
  await storage.removeItem('attendee_id');
  instance.defaults.headers['Authorization'] = '';
};

export const setHeaderAuth = async (token) => {
  await saveToken(token);
  instance.defaults.headers = {...instance.defaults.headers, Authorization: `Bearer ${token}`};
};

export const attendeeFetchData = (url, options) => {
  return instance.get(url, options);
};

export const attendeeSendData = (url, data, options) => {
  return instance.post(url, data, options);
};

export const attendeePutData = (url, data, options) => {
  return instance.put(url, data, options);
};

export const attendeeDeleteData = (url, data) => {
  return instance.delete(url, data);
};